/**
 * SystemStatusWidget
 * Shows system status (manager only)
 * Extracted from ManagerDashboard.js
 */

import React from 'react';
import { useSocket } from '../../../context/SocketContext';

export default function SystemStatusWidget() {
  const { connected } = useSocket();

  return (
    <div className="card">
      <h2 className="text-xl font-display font-bold mb-4">System Status</h2>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <span className="text-gray-600">Backend API</span>
          <span className="badge bg-green-100 text-green-800">Online</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-gray-600">Database</span>
          <span className="badge bg-green-100 text-green-800">Connected</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-gray-600">Real-time Updates</span>
          <span className={`badge ${connected ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
            {connected ? 'Connected' : 'Disconnected'}
          </span>
        </div>
      </div>
    </div>
  );
}
